<div class="container-fluid">
  <h2>{{ 'ADMIN.PORTAL_NEWSLETTER' | translate }}</h2>

  <div class="form-check form-switch mb-2">
    <input class="form-check-input" type="checkbox" id="nlEnabled" [(ngModel)]="enabled" name="enabled">
    <label class="form-check-label" for="nlEnabled">{{ 'PORTAL.NEWSLETTER_ENABLED' | translate }}</label>
  </div>
  <div class="form-group mb-2">
    <label for="nlHeading">{{ 'PORTAL.NEWSLETTER_HEADING' | translate }}</label>
    <input type="text" class="form-control" id="nlHeading" [(ngModel)]="heading" name="heading">
  </div>
  <div class="form-group mb-3">
    <label for="nlBlurb">{{ 'PORTAL.NEWSLETTER_BLURB' | translate }}</label>
    <textarea class="form-control" id="nlBlurb" rows="2" [(ngModel)]="blurb" name="blurb"></textarea>
  </div>
  <button class="btn btn-outline-primary mb-4" (click)="saveSettings()">{{ 'ADMIN.SAVE' | translate }}</button>

  <hr/>
  <h5>{{ 'PORTAL.NEWSLETTER_SUBSCRIBERS' | translate }} ({{ confirmedCount }} {{ 'PORTAL.NEWSLETTER_CONFIRMED' | translate }})</h5>
  <table class="table table-sm">
    <thead>
      <tr><th>{{ 'PORTAL.NEWSLETTER_EMAIL' | translate }}</th><th>{{ 'PORTAL.NEWSLETTER_STATUS' | translate }}</th><th>{{ 'PORTAL.NEWSLETTER_SUBSCRIBED_AT' | translate }}</th><th></th></tr>
    </thead>
    <tbody>
      @for (s of subscribers; track s.id) {
        <tr>
          <td>{{ s.email }}</td>
          <td>{{ s.status }}</td>
          <td>{{ s.subscribedAt | date:'dd/MM/yyyy' }}</td>
          <td class="text-right">
            <button class="btn btn-sm btn-outline-danger" (click)="deleteSubscriber(s)">
              {{ 'ADMIN.DELETE' | translate }}
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>

  <hr/>
  <h5>{{ 'PORTAL.NEWSLETTER_COMPOSE' | translate }}</h5>
  <div class="form-group mb-2">
    <input type="text" class="form-control" [(ngModel)]="broadcastSubject" name="broadcastSubject" [placeholder]="'PORTAL.NEWSLETTER_SUBJECT' | translate">
  </div>
  <div class="form-group mb-2">
    <app-template-editor [elementId]="'newsletterBodyId'" [height]="'25vh'" style="z-index:0"
      (onEditorKeyup)="broadcastBody = $event" [tempValue]="broadcastBody">
    </app-template-editor>
  </div>
  <button class="btn btn-primary mb-4" [disabled]="!canSend()" (click)="sendBroadcast()">
    {{ 'PORTAL.NEWSLETTER_SEND' | translate }}
  </button>

  <hr/>
  <h5>{{ 'PORTAL.NEWSLETTER_HISTORY' | translate }}</h5>
  <table class="table table-sm">
    <thead>
      <tr><th>{{ 'PORTAL.NEWSLETTER_SUBJECT' | translate }}</th><th>{{ 'PORTAL.NEWSLETTER_SENT_AT' | translate }}</th><th>{{ 'PORTAL.NEWSLETTER_RECIPIENTS' | translate }}</th></tr>
    </thead>
    <tbody>
      @for (b of broadcasts; track b.id) {
        <tr><td>{{ b.subject }}</td><td>{{ b.sentAt | date:'dd/MM/yyyy HH:mm' }}</td><td>{{ b.recipientCount }}</td></tr>
      }
    </tbody>
  </table>
</div>
